(function() {
    fp.events = {
        DOCUMENT_READY: 'documentReady',
        CAPTCHA_READY: 'captchaReady',

        INITIALIZED: 'initialized',
        LOADED: 'loaded',
        RENDERED: 'rendered',

        INITIALIZE: 'initialize',
        SEARCH: 'search',
        SEARCH_BEFORE_CHANGE: 'searchBeforeChange',
        RESIZE: 'resize',

        UI_BLOCKED: 'uiblocked',
        UI_UNBLOCKED: 'uiunblocked',

        PAGE_CHANGE: 'pageChange',
        PAGE_CHANGED: 'pageChanged',

        ROUTE_AFTER_CHANGE: 'routeAfterChange',
        ROUTE_BEFORE_CHANGE: 'routeBeforeChange',
        ROUTE_CHANGED: 'routeChanged',

        STATE_VIEW_CHANGED: 'stateViewChanged',
        STATE_CHANGED: 'stateChanged',

        //API_QUEUE_ADDED: 'apiQueueAdded',
        //API_QUEUE_DELETED: 'apiQueueDeleted',

        ADDRESS_BOOK_ADDRESS_ADDED: 'addressBookAddressAdded',
        ADDRESS_BOOK_ADDRESS_MODAL_HIDDEN: 'addressBookModalHidden',

        PRODUCTS_LOADED: 'productsLoaded',
        RECIPES_LOADED: 'recipesLoaded',
        LIST_LOADED: 'listLoaded',
        ORDER_LIST_LOADED: 'orderListLoaded',
        DEPARTMENTS_LOADED: 'departmentsLoaded',
        BREADCRUMB_LOADED: 'breadcrumbLoaded',
        STORE_LOADED: 'storeLoaded', //remove this when Wordpress replaces STORE_LOADED with STORE_CHANGED
        MODULE_LOAD: 'moduleLoad',
        MODULE_RENDERED: 'moduleRendered',
        VIEW_MODULE_LOADED: 'viewModuleLoaded',
        VIEW_MODULE_RENDERED: 'viewModuleRendered',

        SESSION_CHANGED: 'sessionChanged',

        USER_LOADED: 'userLoaded',
        USER_CHANGED: 'userChanged',

        ACCOUNT_CREATED: 'accountCreated',
        ACCOUNT_LOGOUT: 'accountLogout',
        ACCOUNT_SET_TITLE: 'accountSetTitle',
        ACCOUNT_ROUTE_CHANGED: 'accountRouteChanged',

        LIST_ITEM_BEFORE_CHANGE: 'listItemBeforeChange',
        LIST_ITEM_CREATE_NOTE: 'listItemCreateNote',
        LIST_ITEM_UPDATE: 'listItemUpdate',
        LIST_ITEM_ADD: 'listItemAdd',
        LIST_ITEM_INCREMENT: 'listItemIncrement',
        LIST_ITEM_REMOVE: 'listItemRemove',

        LIST_ITEM_CHANGED: 'listItemChanged',

        LIST_CREATE: 'listCreate',
        LIST_DELETE: 'listDelete',
        LIST_ACTIVATE: 'listActivate',
        LIST_RENAME: 'listRename',
        LIST_CHECK_TOGGLE: 'listCheckToggle',
        LIST_ITEMS_CLEAR: 'listItemsClear',
        LIST_ITEMS_REFRESH: 'listItemsRefresh',

        LIST_CREATED: 'listCreated',
        LIST_DELETED: 'listDeleted',
        LIST_RENAMED: 'listRenamed',
        LIST_CHANGED: 'listChanged',
        LIST_ACTIVATED: 'listActivated',
        LIST_REFRESHED: 'listRefreshed',
        LIST_CHECKOUT: 'listCheckout',
        LIST_CHECK_TOGGLED: 'listCheckToggled',
        LIST_ITEMS_CLEARED: 'listItemsCleared',
        LIST_ITEMS_REFRESHED: 'listItemsRefreshed',
        LIST_ITEMS_ADDED: 'listItemsAdded',

        GRID_IMAGE_SIZE_CHANGED: 'gridImageSizeChanged',
        FULFILLMENT_SLOT_CHANGED: 'fulfillmentSlotChanged',

        OFFER_ITEM_CLIPPED: 'offerItemClipped',

        PRODUCT_FAVORITED: 'productFavorited',
        RECIPE_FAVORITED: 'recipeFavorited',

        ORDER_CLEARED: 'orderCleared',
        //ORDER_CHANGE_FULFILLMENT: 'orderChangeFulfillment',
        ORDER_LIST_ITEMS_REFRESHED: 'orderListItemsRefreshed',

        SET_BREADCRUMB_SEARCH: 'setBreadcrumbSearch',
        BREADCRUMB_CHANGE: 'breadcrumbChange',

        //DEPARTMENT_CHANGED: 'departmentChanged',

        MINI_LIST_SHOW: 'miniListShow',
        MINI_LIST_HIDE: 'miniListHide',
        MINI_LIST_HIDDEN: 'miniListHidden',

        PRODUCT_ACTION_OPEN: 'productActionOpen',

        DROPDOWN_CLOSE: 'dropdownClose',
        DROPDOWN_POPOVER_CLOSE: 'dropdownPopOverClose',
        DROPDOWN_POPOVER_OPEN: 'dropdownPopOverOpen',

        MODAL_SHOWN: 'modalShown',
        MODAL_HIDDEN: 'modalHidden',
        PRODUCTS_MODAL_SHOW: 'productsModalShow',
        COUPONS_MODAL_SHOW: 'couponsModalShow',
        PRODUCTS_MODAL_HIDE: 'productsModalHide',
        COUPONS_MODAL_HIDE: 'couponsModalHide',
        FIRST_PRODUCT_ADD_MODAL_SHOW: 'firstProductAddModalShow',
        FIRST_PRODUCT_ADD_MODAL_HIDE: 'firstProductAddModalHide',
        ADD_ALL_PRODUCTS_MODAL_SHOW: 'addAllProductsModalShow',
        ADD_ALL_PRODUCTS_MODAL_HIDE: 'addAllProductsModalHide',
        PRODUCT_DETAIL_MODAL_SHOW: 'productDetailModalShow',
        CONFIRM_MODAL_SHOW: 'confirmModalShow',
        CONFIRM_MODAL_HIDE: 'confirmModalHide',

        STORE_CHANGE: 'storeChange',
        STORE_BEFORE_CHANGE: 'storeBeforeChange',
        STORE_CHANGED: 'storeChanged',
        STORE_AFTER_CHANGE: 'storeAfterChange',

        CHECKOUT_INIT: 'checkoutInit',
        CHECKOUT_COMPLETE: 'checkoutComplete',
        CHECKOUT_SUMMARY_REFRESHED: 'checkoutSummaryRefreshed',
        CHECKOUT_CONFIRMATION_REFRESH: 'checkoutConfirmationRefresh',

        FULFILLMENT_TYPE_CHANGED: 'fulfillmentTypeChanged',

        MEDIA_WIDTH_CHANGE: 'mediaWidthChange',
        WINDOW_RESIZE: 'windowResize',
        WINDOW_ORIENTATION_CHANGED: 'windowOrientationChanged',

        SITE_HEADER_SET_PAGE_TITLE: 'siteHeaderSetPageTitle',

        PAGE_TITLE_SHOW: 'pageTitleShow',
        PAGE_TITLE_HIDE: 'pageTitleHide',
        PAGE_TITLE_SET_CONTENT: 'pageTitleSetContent',

        CIRCULAR_DISPLAY_TYPE_CHANGED: 'circularDisplayTypeChanged',

        TRACK_EVENT: 'trackEvent'
    };
})();